<template>
	<div class="root">
		<MeetingHeader/>
		<div class="container">
			<div class="result-icon">
				<img src="@/assets/order/success.png">
			</div>
			<div class="title">支付成功</div>
			<div class="limit-width order-top">
				<div class="orderno">订单编号: 56457875488</div>
				<div class="orderstatus">已付款</div>
			</div>
			<div class="limit-width product">
				<div class="p-item">
					<div class="p-name">会议室1(大)</div>
					<div class="p-price">￥100.00</div>
				</div>
				<div class="p-item">
					<div class="p-name">VIP2(按摩)</div>
					<div class="p-price">￥58.00</div>
				</div>
				<div class="p-item">
					<div class="p-name">一次性按摩工具</div>
					<div class="p-price">￥30.00</div>
				</div>
			</div>
			<div class="limit-width total">合计：￥188</div>
			<div class="limit-width tips">
				<p style="color:#B176C5;margin-top: 20px;font-size: 20px;">取消政策</p>
				<p style="margin-top: 10px;">可在预约时间前半小时取消，并自动退款;半小时内无法再取消退款。</p>
			</div>
			<div class="bottom">
				<Button @click='goHome' size='large' class='pay-btn' type='primary'>再次预约</Button>
			</div>
		</div>
		
	</div>
</template>

<script>
	import MeetingHeader from '@/components/header/MeetingHeader'
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {
			MeetingHeader,
		},
		computed: {
			...mapState({

			}),
		},
		methods: {
			...mapActions([
				
			]),
			async initData(){

			},
			goHome(){
				this.$router.push('/meeting/home')
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/mixin';
	.root {
		display:block;
		background-color: white;
	}
	.container {
		padding-top:1rem;
		margin:auto;
		max-width: 1400px;
	}
	.result-icon {
		width: 150px;
		height: 150px;
		border-radius: 100px;
		background-color:$green;
		margin:auto;
		display:flex;
		align-items: center;
		justify-content: center;
		margin-top: 60px;
		box-shadow: 1px 1px 20px #dddddd8c;
		img {
			width:80px;
		}
	}
	.title {
		color: $green;
		font-weight: bold;
		@include fontSize($font-size-20);
		text-align:center;
		margin-top: 20px;
	}
	.limit-width {
		max-width: 700px;
		margin:auto;
	}
	.order-top {
		display:flex;
		justify-content: space-between;
		margin-top: 20px;
		border-bottom:1px solid #aaa;
		padding-bottom: 10px;
		.orderno {
			@include fontSize($font-size-16);
		}
		.orderstatus {
			@include fontSize($font-size-14);
			color:$theme-color;
			border:1px solid $theme-color;
			padding:2px 15px;
			border-radius: 20px;
		}
	}
	.product {
		.p-item {
			display:flex;
			justify-content: space-between;
			@include fontSize($font-size-16);
			margin-top: 10px;
		}
	}
	.total {
		margin-top: 30px;
		text-align: right;
		@include fontSize($font-size-24);
		color:red;
		padding-bottom: 10px;
		border-bottom:1px solid #aaa;
	}
	.bottom {
		display:flex;
		margin:40px 0;
		justify-content: center;
		.pay-btn {
			width:330px;
			border-radius: 30px;
			height:50px;
		}
	}
	@media (max-width: 768px){
		.container {
			padding:0 10px;
		}
	}
</style>